const gather = {}
gather.templateLanguages = [
  {label: '南非荷兰语', value: 'af'},
  {label: '阿尔巴尼亚语', value: 'sq'},
  {label: '阿拉伯语', value: 'ar'},
  {label: '阿塞拜疆语', value: 'az'},
  {label: '孟加拉语', value: 'bn'},
  {label: '保加利亚语', value: 'bg'},
  {label: '加泰罗尼亚语', value: 'ca'},
  {label: '简体中文（中国内地）', value: 'zh_CN'},
  {label: '繁体中文（香港）', value: 'zh_HK'},
  {label: '繁体中文（台湾）', value: 'zh_TW'},
  {label: '克罗地亚语', value: 'hr'},
  {label: '捷克语', value: 'cs'},
  {label: '丹麦语', value: 'da'},
  {label: '荷兰语', value: 'nl'},
  {label: '英语', value: 'en'},
  {label: '英语（英国）', value: 'en_GB'},
  {label: '英语（美国）', value: 'en_US'},
  {label: '爱沙尼亚语', value: 'et'},
  {label: '菲律宾语', value: 'fil'},
  {label: '芬兰语', value: 'fi'},
  {label: '法语', value: 'fr'},
  {label: '德语', value: 'de'},
  {label: '希腊语', value: 'el'},
  {label: '古吉拉特语', value: 'gu'},
  {label: '豪萨语', value: 'ha'},
  {label: '希伯来语', value: 'he'},
  {label: '印地语', value: 'hi'},
  {label: '匈牙利语', value: 'hu'},
  {label: '印尼语', value: 'id'},
  {label: '爱尔兰语', value: 'ga'},
  {label: '意大利语', value: 'it'},
  {label: '日语', value: 'ja'},
  {label: '卡纳达语', value: 'kn'},
  {label: '哈萨克语', value: 'kk'},
  {label: '韩语', value: 'ko'},
  {label: '老挝语', value: 'lo'},
  {label: '拉脱维亚语', value: 'lv'},
  {label: '立陶宛语', value: 'lt'},
  {label: '马其顿语', value: 'mk'},
  {label: '马来语', value: 'ms'},
  {label: '马拉雅拉姆语', value: 'ml'},
  {label: '马拉地语', value: 'mr'},
  {label: '挪威语', value: 'nb'},
  {label: '波斯语', value: 'fa'},
  {label: '波兰语', value: 'pl'},
  {label: '葡萄牙语（巴西）', value: 'pt_BR'},
  {label: '葡萄牙语（葡萄牙）', value: 'pt_PT'},
  {label: '旁遮普语', value: 'pa'},
  {label: '罗马尼亚语', value: 'ro'},
  {label: '俄语', value: 'ru'},
  {label: '塞尔维亚语', value: 'sr'},
  {label: '斯洛伐克语', value: 'sk'},
  {label: '斯洛文尼亚语', value: 'sl'},
  {label: '西班牙语', value: 'es'},
  {label: '西班牙语（阿根廷）', value: 'es_AR'},
  {label: '西班牙语（西班牙）', value: 'es_ES'},
  {label: '西班牙语（墨西哥）', value: 'es_MX'},
  {label: '斯瓦希里语', value: 'sw'},
  {label: '瑞典语', value: 'sv'},
  {label: '泰米尔语', value: 'ta'},
  {label: '泰卢固语', value: 'te'},
  {label: '泰语', value: 'th'},
  {label: '土耳其语', value: 'tr'},
  {label: '乌克兰语', value: 'uk'},
  {label: '乌尔都语', value: 'ur'},
  {label: '乌兹别克语', value: 'uz'},
  {label: '越南语', value: 'vi'},
  {label: '祖鲁语', value: 'zu'}
]

gather.countrycodeselector = [
  {
    label: '阿富汗-Afghanistan +',
    value: 93
  }, {
    label: '阿尔巴尼亚-Albania (Shqipëri) +',
    value: 355
  }, {
    label: '阿尔及利亚-Algeria +',
    value: 213
  }, {
    label: '美属萨摩亚-American Samoa +',
    value: 1684
  }, {
    label: '安道尔-Andorra +',
    value: 376
  }, {
    label: '安哥拉-Angola +',
    value: 244
  }, {
    label: '安圭拉-Anguilla +',
    value: 1264
  }, {
    label: '安提瓜和巴布达-Antigua and Barbuda +',
    value: 1268
  }, {
    label: '阿根廷-Argentina +',
    value: 54
  }, {
    label: '亚美尼亚-Armenia (Հայաստան) +',
    value: 374
  }, {
    label: '阿鲁巴-Aruba +',
    value: 297
  }, {
    label: '阿森松岛-Ascension Island +',
    value: 290
  }, {
    label: '澳大利亚-Australia +',
    value: 61
  }, {
    label: '奥地利-Austria (Österreich) +',
    value: 43
  }, {
    label: '阿塞拜疆-Azerbaijan (Azərbaycan) +',
    value: 994
  }, {
    label: '巴林-Bahrain +',
    value: 973
  }, {
    label: '孟加拉国-Bangladesh (বাংলাদেশ) +',
    value: 880
  }, {
    label: '巴巴多斯-Barbados +',
    value: 1246
  }, {
    label: '白俄罗斯-Belarus (Беларусь) +',
    value: 375
  }, {
    label: '比利时-Belgium (België) +',
    value: 32
  }, {
    label: '伯利兹-Belize +',
    value: 501
  }, {
    label: '贝宁-Benin (Bénin) +',
    value: 229
  }, {
    label: '百慕大-Bermuda +',
    value: 1441
  }, {
    label: '不丹-Bhutan (འབྲུག) +',
    value: 975
  }, {
    label: '玻利维亚-Bolivia +',
    value: 591
  }, {
    label: '波黑-Bosnia and Herzegovina (Босна и Херцеговина) +',
    value: 387
  }, {
    label: '博茨瓦纳-Botswana +',
    value: 267
  }, {
    label: '巴西-Brazil (Brasil) +',
    value: 55
  }, {
    label: '英属印度洋领地-British Indian Ocean Territory +',
    value: 246
  }, {
    label: '英属维尔京群岛-British Virgin Islands +',
    value: 1284
  }, {
    label: '文莱-Brunei Darussalam +',
    value: 673
  }, {
    label: '保加利亚-Bulgaria (България) +',
    value: 359
  }, {
    label: '布基纳法索-Burkina Faso +',
    value: 226
  }, {
    label: '布隆迪-Burundi (Uburundi) +',
    value: 257
  }, {
    label: '柬埔寨-Cambodia (កម្ពុជា) +',
    value: 855
  }, {
    label: '喀麦隆-Cameroon (Cameroun) +',
    value: 237
  }, {
    label: '加拿大-Canada +',
    value: 1
  }, {
    label: '佛得角-Cape Verde (Kabu Verdi) +',
    value: 238
  }, {
    label: '荷兰加勒比区-Caribbean Netherlands +',
    value: 599
  }, {
    label: '开曼群岛-Cayman Islands +',
    value: 1345
  }, {
    label: '中非-Central African Republic (République centrafricaine) +',
    value: 236
  }, {
    label: '乍得-Chad (Tchad) +',
    value: 235
  }, {
    label: '智利-Chile +',
    value: 56
  }, {
    label: '中国-China (中国) +',
    value: 86
  }, {
    label: '哥伦比亚-Colombia +',
    value: 57
  }, {
    label: '科摩罗-Comoros +',
    value: 269
  }, {
    label: '刚果（布）-Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo) +',
    value: 243
  }, {
    label: '刚果（金）-Congo (Republic) (Congo-Brazzaville) +',
    value: 242
  }, {
    label: '库克群岛-Cook Islands +',
    value: 682
  }, {
    label: '哥斯达黎加-Costa Rica +',
    value: 506
  }, {
    label: '科特迪瓦-Côte d’Ivoire +',
    value: 225
  }, {
    label: '克罗地亚-Croatia (Hrvatska) +',
    value: 385
  }, {
    label: '古巴-Cuba +',
    value: 53
  }, {
    label: '库拉索-Curaçao +',
    value: 599
  }, {
    label: '塞浦路斯-Cyprus (Κύπρος) +',
    value: 357
  }, {
    label: '捷克-Czech Republic (Česká republika) +',
    value: 420
  }, {
    label: '丹麦-Denmark (Danmark) +',
    value: 45
  }, {
    label: '吉布提-Djibouti +',
    value: 253
  }, {
    label: '多米尼克-Dominica +',
    value: 1767
  }, {
    label: '多米尼加-Dominican Republic (República Dominicana) +',
    value: 1
  }, {
    label: '厄瓜多尔-Ecuador +',
    value: 593
  }, {
    label: '埃及-Egypt +',
    value: 20
  }, {
    label: '萨尔瓦多-El Salvador +',
    value: 503
  }, {
    label: '赤道几内亚-Equatorial Guinea (Guinea Ecuatorial) +',
    value: 240
  }, {
    label: '厄立特里亚-Eritrea +',
    value: 291
  }, {
    label: '爱沙尼亚-Estonia (Eesti) +',
    value: 372
  }, {
    label: '埃塞俄比亚-Ethiopia +',
    value: 251
  }, {
    label: '福克兰群岛（马尔维纳斯）-Falkland Islands (Islas Malvinas) +',
    value: 500
  }, {
    label: '法罗群岛-Faroe Islands (Føroyar) +',
    value: 298
  }, {
    label: '斐济-Fiji +',
    value: 679
  }, {
    label: '芬兰-Finland (Suomi) +',
    value: 358
  }, {
    label: '法国-France +',
    value: 33
  }, {
    label: '法属圭亚那-French Guiana (Guyane française) +',
    value: 594
  }, {
    label: '法属波利尼西亚-French Polynesia (Polynésie française) +',
    value: 689
  }, {
    label: '加蓬-Gabon +',
    value: 241
  }, {
    label: '格鲁吉亚-Georgia (საქართველო) +',
    value: 995
  }, {
    label: '德国-Germany (Deutschland) +',
    value: 49
  }, {
    label: '加纳-Ghana (Gaana) +',
    value: 233
  }, {
    label: '直布罗陀-Gibraltar +',
    value: 350
  }, {
    label: '希腊-Greece (Ελλάδα) +',
    value: 30
  }, {
    label: '格陵兰-Greenland (Kalaallit Nunaat) +',
    value: 299
  }, {
    label: '格林纳达-Grenada +',
    value: 1473
  }, {
    label: '瓜德罗普-Guadeloupe +',
    value: 590
  }, {
    label: '关岛-Guam +',
    value: 1671
  }, {
    label: '危地马拉-Guatemala +',
    value: 502
  }, {
    label: '根西岛-Guernsey +',
    value: 1481
  }, {
    label: '几内亚-Guinea (Guinée) +',
    value: 224
  }, {
    label: '几内亚比绍-Guinea-Bissau (Guiné Bissau) +',
    value: 245
  }, {
    label: '圭亚那-Guyana +',
    value: 592
  }, {
    label: '海地-Haiti +',
    value: 509
  }, {
    label: '洪都拉斯-Honduras +',
    value: 504
  }, {
    label: '香港-Hong Kong (香港) +',
    value: 852
  }, {
    label: '匈牙利-Hungary (Magyarország) +',
    value: 36
  }, {
    label: '冰岛-Iceland (Ísland) +',
    value: 354
  }, {
    label: '印度-India (भारत) +',
    value: 91
  }, {
    label: '印度尼西亚-Indonesia +',
    value: 62
  }, {
    label: '伊朗-Iran +',
    value: 98
  }, {
    label: '伊拉克-Iraq +',
    value: 964
  }, {
    label: '爱尔兰-Ireland +',
    value: 353
  }, {
    label: '马恩岛-Isle of Man +',
    value: 44
  }, {
    label: '以色列-Israel +',
    value: 972
  }, {
    label: '意大利-Italy (Italia) +',
    value: 39
  }, {
    label: '牙买加-Jamaica +',
    value: 1876
  }, {
    label: '日本-Japan (にほんこく) +',
    value: 81
  }, {
    label: '泽西岛-Jersey +',
    value: 44
  }, {
    label: '约旦-Jordan +',
    value: 962
  }, {
    label: '哈萨克斯坦-Kazakhstan (Казахстан) +',
    value: 7
  }, {
    label: '肯尼亚-Kenya +',
    value: 254
  }, {
    label: '基里巴斯-Kiribati +',
    value: 686
  }, {
    label: '科索沃-Kosovo +',
    value: 383
  }, {
    label: '科威特-Kuwait +',
    value: 965
  }, {
    label: '吉尔吉斯斯坦-Kyrgyzstan (Кыргызстан) +',
    value: 996
  }, {
    label: '老挝-Laos (ລາວ) +',
    value: 856
  }, {
    label: '拉脱维亚-Latvia (Latvija) +',
    value: 371
  }, {
    label: '黎巴嫩-Lebanon +',
    value: 961
  }, {
    label: '莱索托-Lesotho +',
    value: 266
  }, {
    label: '利比里亚-Liberia +',
    value: 231
  }, {
    label: '利比亚-Libya +',
    value: 218
  }, {
    label: '列支敦士登-Liechtenstein +',
    value: 423
  }, {
    label: '立陶宛-Lithuania (Lietuva) +',
    value: 370
  }, {
    label: '卢森堡-Luxembourg +',
    value: 352
  }, {
    label: '澳门-Macao (澳門) +',
    value: 853
  }, {
    label: '前南马其顿-Macedonia (FYROM) (Македонија) +',
    value: 389
  }, {
    label: '马达加斯加-Madagascar (Madagasikara) +',
    value: 261
  }, {
    label: '马拉维-Malawi +',
    value: 265
  }, {
    label: '马来西亚-Malaysia +',
    value: 60
  }, {
    label: '马尔代夫-Maldives +',
    value: 960
  }, {
    label: '马里-Mali +',
    value: 223
  }, {
    label: '马耳他-Malta +',
    value: 356
  }, {
    label: '马绍尔群岛-Marshall Islands +',
    value: 692
  }, {
    label: '马提尼克-Martinique +',
    value: 596
  }, {
    label: '毛里塔尼亚-Mauritania +',
    value: 222
  }, {
    label: '毛里求斯-Mauritius (Moris) +',
    value: 230
  }, {
    label: '马约特-Mayotte +',
    value: 262
  }, {
    label: '墨西哥-Mexico (México) +',
    value: 52
  }, {
    label: '密克罗尼西亚-Micronesia +',
    value: 691
  }, {
    label: '摩尔多瓦-Moldova (Republica Moldova) +',
    value: 373
  }, {
    label: '摩纳哥-Monaco +',
    value: 377
  }, {
    label: '蒙古-Mongolia (Монгол) +',
    value: 976
  }, {
    label: '黑山-Montenegro (Crna Gora) +',
    value: 382
  }, {
    label: '蒙特塞拉特-Montserrat +',
    value: 1664
  }, {
    label: '摩洛哥-Morocco+',
    value: 212
  }, {
    label: '莫桑比克-Mozambique (Moçambique) +',
    value: 258
  }, {
    label: '缅甸-Myanmar (Burma) (မြန်မာ) +',
    value: 95
  }, {
    label: '纳米尼亚-Namibia (Namibië) +',
    value: 264
  }, {
    label: '瑙鲁-Nauru +',
    value: 674
  }, {
    label: '尼泊尔-Nepal (नेपाल) +',
    value: 977
  }, {
    label: '荷兰-Netherlands (Nederland) +',
    value: 31
  }, {
    label: '新喀里多尼亚-New Caledonia (Nouvelle-Calédonie) +',
    value: 687
  }, {
    label: '新西兰-New Zealand +',
    value: 64
  }, {
    label: '尼加拉瓜-Nicaragua +',
    value: 505
  }, {
    label: '尼日尔-Niger (Nijar) +',
    value: 227
  }, {
    label: '尼日利亚-Nigeria +',
    value: 234
  }, {
    label: '纽埃-Niue +',
    value: 683
  }, {
    label: '诺福克岛-Norfolk Island +',
    value: 672
  }, {
    label: '朝鲜-North Korea (조선민주주의인민공화국) +',
    value: 850
  }, {
    label: '北马里亚纳-Northern Mariana Islands +',
    value: 1670
  }, {
    label: '挪威-Norway (Norge) +',
    value: 47
  }, {
    label: '阿曼-Oman +',
    value: 968
  }, {
    label: '巴基斯坦-Pakistan +',
    value: 92
  }, {
    label: '帕劳-Palau +',
    value: 680
  }, {
    label: '巴勒斯坦-Palestine +',
    value: 970
  }, {
    label: '巴拿马-Panama (Panamá) +',
    value: 507
  }, {
    label: '巴布亚新几内亚-Papua New Guinea +',
    value: 675
  }, {
    label: '巴拉圭-Paraguay +',
    value: 595
  }, {
    label: '秘鲁-Peru (Perú) +',
    value: 51
  }, {
    label: '菲律宾-Philippines +',
    value: 63
  }, {
    label: '皮特凯恩-Poland (Polska) +',
    value: 48
  }, {
    label: '葡萄牙-Portugal +',
    value: 351
  }, {
    label: '波多黎各-Puerto Rico +',
    value: 1
  }, {
    label: '卡塔尔-Qatar +',
    value: 974
  }, {
    label: '留尼汪-Réunion (La Réunion) +',
    value: 262
  }, {
    label: '罗马尼亚-Romania (România) +',
    value: 40
  }, {
    label: '俄罗斯-Russia (Россия) +',
    value: 7
  }, {
    label: '卢旺达-Rwanda +',
    value: 250
  }, {
    label: '圣赫勒拿-Saint Helena +',
    value: 290
  }, {
    label: '圣基茨和尼维斯-Saint Kitts and Nevis +',
    value: 1869
  }, {
    label: '圣卢西亚-Saint Lucia +',
    value: 1758
  }, {
    label: '圣马丁岛-Saint Martin (Saint-Martin) +',
    value: 590
  }, {
    label: '圣皮埃尔和密克隆-Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon) +',
    value: 508
  }, {
    label: '圣文森特和格林纳丁斯-Saint Vincent and the Grenadines +',
    value: 1784
  }, {
    label: '萨摩亚-Samoa +',
    value: 685
  }, {
    label: '圣马力诺-San Marino +',
    value: 378
  }, {
    label: '圣多美和普林西比-São Tomé and Príncipe (São Tomé e Príncipe) +',
    value: 239
  }, {
    label: '沙特阿拉伯-Saudi Arabia +',
    value: 966
  }, {
    label: '塞内加尔-Senegal (Sénégal) +',
    value: 221
  }, {
    label: '塞尔维亚-Serbia (Србија) +',
    value: 381
  }, {
    label: '塞舌尔-Seychelles +',
    value: 248
  }, {
    label: '塞拉利昂-Sierra Leone +',
    value: 232
  }, {
    label: '新加坡-Singapore +',
    value: 65
  }, {
    label: '荷属圣马丁-Sint Maarten +',
    value: 1721
  }, {
    label: '斯洛伐克-Slovakia (Slovensko) +',
    value: 421
  }, {
    label: '斯洛文尼亚-Slovenia (Slovenija) +',
    value: 386
  }, {
    label: '所罗门群岛-Solomon Islands +',
    value: 677
  }, {
    label: '索马里-Somalia (Soomaaliya) +',
    value: 252
  }, {
    label: '南非-South Africa +',
    value: 27
  }, {
    label: '韩国-South Korea (대한민국) +',
    value: 82
  }, {
    label: '南苏丹-South Sudan +',
    value: 211
  }, {
    label: '西班牙-Spain (España) +',
    value: 34
  }, {
    label: '斯里兰卡-Sri Lanka (ශ්‍රී ලංකාව) +',
    value: 94
  }, {
    label: '苏丹-Sudan +',
    value: 249
  }, {
    label: '苏里南-Suriname +',
    value: 597
  }, {
    label: '斯瓦尔巴岛和扬马延岛-Svalbard and Jan Mayen +',
    value: 47
  }, {
    label: '斯威士兰-Swaziland +',
    value: 268
  }, {
    label: '瑞典-Sweden (Sverige) +',
    value: 46
  }, {
    label: '瑞士-Switzerland (Schweiz) +',
    value: 41
  }, {
    label: '叙利亚-Syria +',
    value: 963
  }, {
    label: '台湾-Taiwan (台灣) +',
    value: 886
  }, {
    label: '塔吉克斯坦-Tajikistan +',
    value: 992
  }, {
    label: '坦桑尼亚-Tanzania +',
    value: 255
  }, {
    label: '泰国-Thailand (ไทย) +',
    value: 66
  }, {
    label: '巴哈马-The Bahamas +',
    value: 1242
  }, {
    label: '冈比亚-The Gambia +',
    value: 220
  }, {
    label: '东帝汶-Timor-Leste +',
    value: 670
  }, {
    label: '多哥-Togo +',
    value: 228
  }, {
    label: '托克劳-Tokelau +',
    value: 690
  }, {
    label: '汤加-Tonga +',
    value: 676
  }, {
    label: '特立尼达和多巴哥-Trinidad and Tobago +',
    value: 1868
  }, {
    label: '突尼斯-Tunisia  +',
    value: 216
  }, {
    label: '土耳其-Turkey (Türkiye) +',
    value: 90
  }, {
    label: '土库曼斯坦-Turkmenistan +',
    value: 993
  }, {
    label: '特克斯和凯科斯群岛-Turks and Caicos Islands +',
    value: 1649
  }, {
    label: '图瓦卢-Tuvalu +',
    value: 688
  }, {
    label: '美国-United States +',
    value: 1
  }, {
    label: '英国-United Kingdom +',
    value: 44
  }, {
    label: '美属维尔京群岛-U.S. Virgin Islands +',
    value: 1340
  }, {
    label: '乌干达-Uganda +',
    value: 256
  }, {
    label: '乌克兰-Ukraine (Україна) +',
    value: 380
  }, {
    label: '阿拉伯联合酋长国-United Arab Emirates +',
    value: 971
  }, {
    label: '乌拉圭-Uruguay +',
    value: 598
  }, {
    label: '乌兹别克斯坦-Uzbekistan (Oʻzbekiston) +',
    value: 998
  }, {
    label: '瓦努阿图-Vanuatu +',
    value: 678
  }, {
    label: '梵蒂冈城-Vatican City (Città del Vaticano) +',
    value: 379
  }, {
    label: '委内瑞拉-Venezuela +',
    value: 58
  }, {
    label: '越南-Vietnam (Việt Nam) +',
    value: 84
  }, {
    label: '瓦利斯和富图纳-Wallis and Futuna +',
    value: 681
  }, {
    label: '西撒哈拉-Western Sahara +',
    value: 212
  }, {
    label: '也门-Yemen +',
    value: 967
  }, {
    label: '赞比亚-Zambia +',
    value: 260
  }, {
    label: '津巴布韦-Zimbabwe +',
    value: 263
  }, {
    label: '奥兰群岛-Åland Islands +',
    value: 358
  }
]
// 语言按照字母排序
gather.templateLanguages.sort((x, y) => {
  return x['label'].localeCompare(y['label'])
})
export default gather



// WEBPACK FOOTER //
// ./src/assets/templateLanguages/templateLanguages.js